function settings(state = {
  settings: [],
  fetching: false,
  fetched: false,
  gen_set_fetched: false,
  fees_fetched: false,
  stor_set_fetched:false,
  currency_fetched:false,
  turnaround_fetched:false,
  year_fetched:false,
  destinationSettings:false,
  destinationFetched:false,
  globalSettings:null,
  globalFetched:false,
  error: null,
  notes: [],

}, action){
  switch (action.type) {
    case 'GET_PER_POUND_VALUE_FULFILLED':{
      return{
        ...state,
        fetched:true,
        estimate: action.payload,
      }
    }
    case 'GET_PER_POUND_VALUE_REJECTED':{
      return {
        ...state,
        fetched:false,
        error: action.payload,
      }
    }
    case 'GET_GENERAL_SETTINGS_FULFILLED':{
      return{
        ...state,
        gen_set_fetched:true,
        general_settings: action.payload,
      }
    }
    case 'GET_GENERAL_SETTINGS_REJECTED':{
      return {
        ...state,
        gen_set_fetched:false,
        error: action.payload,
      }
    }
    case 'GET_STORAGE_SETTINGS_FULFILLED':{
      return{
        ...state,
        stor_set_fetched:true,
        storage_settings: action.payload,
      }
    }
    case 'GET_STORAGE_SETTINGS_REJECTED':{
      return {
        ...state,
        stor_set_fetched:false,
        error: action.payload,
      }
    }
    case 'GET_FEES_FULFILLED':{
      return{
        ...state,
        fees_fetched:true,
        fees: action.payload,
      }
    }
    case 'GET_FEES_REJECTED':{
      return {
        ...state,
        fees_fetched:false,
        error: action.payload,
      }
    }
    case 'GET_CURRENCY_FULFILLED':{
    return{
      ...state,
      currency_fetched:true,
      currency: action.payload,
    }
  }
    case 'GET_CURRENCY_REJECTED':{
      return {
        ...state,
        currency_fetched:false,
        error: action.payload,
      }
    }
   case 'GET_TURNAROUND_FULFILLED':{
    return{
      ...state,
      turnaround_fetched:true,
      turnaround: action.payload,
    }
  }
    case 'GET_TURNAROUND_REJECTED':{
      return {
        ...state,
        turnaround_fetched:false,
        error: action.payload,
      }
    }
    case 'GET_YEAR_FULFILLED':{
     return{
       ...state,
       year_fetched:true,
       year: action.payload,
     }
   }
   case 'GET_YEAR_REJECTED':{
     return {
       ...state,
       year_fetched:false,
       error: action.payload,
     }
   } 
   case 'GET_DESTINATION_SETTINGS_FULFILLED':{
    return{
      ...state,
      destinationFetched:true,
      destinationSettings: action.payload,
    }
  }
  case 'GET_DESTINATION_SETTINGS_REJECTED':{
    return {
      ...state,
      destinationFetched:false,
      error: action.payload,
    }
  } 
  case 'GET_GLOBAL_SETTINGS_FULFILLED':{
    const noteSettings = action.payload.data.find(setting => setting.description.includes('Checkout Summary Notes'))
    let currentNotes = [];
    try {
      const formattedSettings = JSON.parse(noteSettings.settings)
      const cleanedText = formattedSettings.notes.value.replace(/•/g, ''); 

      currentNotes = cleanedText.split('\n');
      } catch(err) {
        currentNotes = [];
    }

   return{
     ...state,
     globalFetched:true,
     globalSettings: action.payload,
     notes: currentNotes,
   }
 }
 case 'GET_GLOBAL_SETTINGS_REJECTED':{
   return {
     ...state,
     globalFetched:false,
     error: action.payload,
   }
 }  
        default: break

   }
   return state;
}
export default settings;



/** WEBPACK FOOTER **
 ** ./src/reducers/settings.js
 **/